import './styles.css';

import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import type { IBaseCall, IBaseProps, Result } from 'bz-core-controls/modal-new/confirmation';
import React from 'react';
import ErrorPanel from '../error-panel';
import Actions from './controls/actions';

export interface ISaveCheckDialogProps extends IBaseProps {
  onYes: () => void;
  onNo: () => void;
  onCancel: () => void;
  preventSaveIfErrored?: boolean;
}

export interface ISaveCheckCall extends Omit<IBaseCall, 'title' | 'contents'> {
  title?: React.ReactNode;
  contents?: React.ReactNode;
}

export type SaveCheckResult = Result.yes | Result.no | Result.cancel;

class SaveCheckDialog extends React.Component<ISaveCheckDialogProps> {
  static readonly defaultProps: Partial<ISaveCheckDialogProps> = {
    title: 'Save your changes?',
    contents: 'Do you wish to save your changes before closing?'
  };

  render() {
    const { className, hasErrors } = this;
    const {
      actionProps,
      contents,
      contentProps,
      dialogProps,
      errors,
      errorsTitle,
      open,
      title,
      titleProps,
      onErrorsOk,
      onErrorsCancel,
      preventSaveIfErrored,
      onYes,
      onNo,
      onCancel
    } = this.props;

    let actions;
    let errorPanel;
    if (hasErrors) {
      errorPanel = (
        <ErrorPanel
          className={this.props.className}
          errors={errors as string[]}
          title={errorsTitle}
          onOk={onErrorsOk}
          onCancel={onErrorsCancel}
          preventSaveIfErrored={preventSaveIfErrored}
        />
      );
    } else {
      actions = (
        <Actions
          className={className}
          actionProps={actionProps}
          onYes={onYes}
          onNo={onNo}
          onCancel={onCancel}
        />
      );
    }

    return (
      <Dialog
        {...dialogProps}
        className={`${className} dialog`}
        classes={{ container: `${className} !items-center justify-center` }}
        open={open}
      >
        <DialogTitle {...titleProps} className={`${className} title`}>
          {title}
        </DialogTitle>
        <DialogContent {...contentProps} className={`${className} content`}>
          {contents}
          {errorPanel}
        </DialogContent>
        {actions}
      </Dialog>
    );
  }

  private get className(): string {
    const { className } = this.props;
    const classNames = ['bz-controls bz-modal save-check-dialog'];

    if (!!className) {
      classNames.push(className);
    }

    return classNames.join(' ');
  }

  private get hasErrors(): boolean {
    const { errors } = this.props;

    return !!errors && errors.length > 0;
  }
}

export default SaveCheckDialog;
